import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { UtilService } from '@app/core/services/util.service';
import { AuthSessionService } from '@app/core/services/auth-session.service';
import { SigninService } from '@app/authentication/services/signin.service';
import { FirebaseDataService } from '@app/shared/services/firebase-data.service';
import { APP_CONFIG } from '@environment/environment';

@Component({
    selector: 'app-nav-profile-menu',
    templateUrl: './nav-popover.html',
    styleUrls: ['./nav-popover.scss'],
    standalone: false
})
export class NavProfileMenuComponent {
  @Input() public userType: any;
  public installedVersion: any;

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private alertCtrl: AlertController,
    private utilService: UtilService,
    private authSessionService: AuthSessionService,
    private signinService: SigninService,
    private fbDatabase: FirebaseDataService
  ) {}

  public async dismiss() {
    await this.modalCtrl.dismiss();
  }
  public ngOnInit(){
    this.installedVersion = APP_CONFIG.WebVersion;
  }

  public async profile() {
    await this.dismiss();
    this.router.navigateByUrl('profile-setup');
  }

  public async navigateTo(route: string) {
    await this.dismiss();
    const navigationExtras = {
      state: {
        userType: this.userType,
      },
    };
    this.router.navigate([`/${route}`], navigationExtras);
  }

  public async support() {
    await this.dismiss();
    this.fbDatabase.supportLink().then((data: any) => {
      const ref = window.open(data, '_blank');
    });
  }

  public async logout() {
    await this.dismiss();
    const alert = await this.alertCtrl.create({
      header: 'Logout!',
      subHeader: 'You want to Logout?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'Yes',
          handler: () => {
            this.utilService.showSpinnerLoader();
            this.signinService.sendLogout();
            this.authSessionService.logOut();
          },
        },
      ],
      backdropDismiss: false,
    });
    await alert.present();
  }
}